export default __webpack_public_path__ + "static/media/capacity_reserve_icon.b8066c6c.svg";